@if (
  {
    placeholder: placeholder(),
    searchButton: searchButton(),
    searchValue: searchValue(),
    autoCompleteValues: autoCompleteValues()
  };
  as STATE
) {
  <form [formGroup]="searchForm" (ngSubmit)="onSubmit()" class="search-input">
    <input
      type="text"
      #input
      formControlName="search"
      [placeholder]="STATE.placeholder || 'Rechercher un élément ici'"
      [matAutocomplete]="auto"
      autocomplete="off"
      class="search-input__input"
      (change)="onSubmit()"
    />

    <mat-autocomplete
      [autoActiveFirstOption]="false"
      [displayWith]="selectOptionDisplayFn"
      #auto="matAutocomplete"
      (optionSelected)="emitSearch($event.option.value.value)"
    >
      @if (STATE.autoCompleteValues; as autoCompleteValues) {
        @for (option of autoCompleteValues; track $index) {
          <mat-option [value]="option">
            <div class="mat-option__title">
              {{ option.name }}
            </div>
          </mat-option>
        }
      }
    </mat-autocomplete>

    <button
      type="button"
      class="search-input__clear-button"
      [class.__clear-button--big]="!STATE.searchButton"
      [class.search-input__clear-button_hidden]="
        !STATE.searchValue || STATE.searchValue.length === 0
      "
      [disabled]="!STATE.searchValue || STATE.searchValue.length === 0"
      (click)="onCleanSearch()"
    >
      <mat-icon svgIcon="dgi-cancel" color="primary"></mat-icon>
    </button>

    <button
      *ngIf="STATE.searchButton"
      type="submit"
      class="search-input__button"
    >
      <mat-icon svgIcon="dgi-search"></mat-icon>
    </button>
  </form>
}
